import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityServiceForMedicalService } from '../../../services/utility-service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT, AuthService } from 'src/app/shared';
import * as UserDataConfig from '../../../../user-details/config/user-data.config';
import { Observable, Subscription } from 'rxjs';
import { RefNo } from 'src/app/model/ngrx';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { SyncService } from '../../../services/sync.service';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-doctor-details',
  templateUrl: './doctor-details.component.html',
  styleUrls: ['./doctor-details.component.scss']
})
export class DoctorDetailsComponent implements OnInit {

  contentData: any;
  public doctorForm: UntypedFormGroup;
  public userInputDetail = UserDataConfig.ElementsConfig;
  referenceNumberStore: Observable<RefNo[]>;
  underwritingDataHOStore: Observable<any[]>;
  referenceNumber: RefNo;
  underwritingDataHO: any;
  isHOView = false;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private CMSData;
  private rangeValidationData: any;

  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute,
              private router: Router,
              public el: ElementRef,
              public utilityServiceForMedicalService: UtilityServiceForMedicalService,
              //changed to public to access in html file
              private store: Store<AppState>,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private utilService: UtilService,
              private healthService: HealthService,
              private syncService: SyncService, private authService: AuthService) {
      this.contentData = this.activatedRoute.snapshot.data.contentData.doctorDetails;
      this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
      this.underwritingDataHOStore = this.store.select(STORE_VAL.underwriting_data_ho);
      this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
      this.referenceNumberStore.subscribe((val) => {
        if (val.length > 0) {
          this.referenceNumber = val[0];
        }
      });
      this.underwritingDataHOStore.subscribe((val) => {
        if (val.length > 0) {
          this.underwritingDataHO = val[0];
        }
      });
   }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.getLifestyleRange();
    this.userInputDetail['buttonConfig']['label'] = 'Next';
    this.userInputDetail['buttonConfig']['name'] = 'Next';
    if (this.referenceNumber) {
      this.contentData.details[0].referenceNum = this.contentData.details[0].referenceNum.replace('{}', this.referenceNumber?.quoteReferenceNumber);
    }
    this.doctorForm = this.fb.group({

    });
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
  }

  saveAfterLogin() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
  }
  saveAfterLogout() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }

  
  gotoNext = () => {
    if ( this.isHOView ) {
      if (this.underwritingDataHO && this.underwritingDataHO['underwritingLife'] === 'S') {
     // this.router.navigate(['/ho-underwriting/dependant-lifestyle']);
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL('/ho-underwriting/dependant-lifestyle', '/ho-underwriting/summary')], { replaceUrl: true });
      } else {
       // this.router.navigate(['/ho-underwriting/dependant-lifestyle']);
        this.router.navigate(['/ho-underwriting/summary'], { replaceUrl: true });
      }
    } else {
  // tslint:disable-next-line: max-line-length
  this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL('/home/your-dependant', '/quote/your-product-options')], { replaceUrl: true });
    }
  }

  ngOnDestroy() {
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }

  getLifestyleRange() {
    this.healthService.getRangeValidation()
      .subscribe(res => {
        this.rangeValidationData = res.values;
        this.syncService.setRangeValidationJson(this.rangeValidationData);
      });
  }

       /** Code block for CMS */
       GetCMSDataServiceMapper() {
        //console.log('changed value = ', this.contentData);
        const URL = SERVICE_END_POINT.higherEnvironment.CMS_DoctorsDetailsQuote;
        this.utilService.getCMSData(URL).subscribe(res => {
          //console.log('2 GetCMSDataService => ', res);
          this.CMSData = res;
          if (this.CMSData) {
            /** In the line below we are over-writing the healthData object values with CMSData object values */
            this.contentData.header = this.CMSData.string_DoctorsDetailsQuoteTitle;
            this.contentData.introduction = this.CMSData.string_DoctorsDetailsQuoteSubtitle;
            this.contentData.details[0].text = this.CMSData.string_DoctorsDetailsQuoteWording;
            this.contentData.details[1].text = this.CMSData.string_DoctorsDetailsQuoteWording2;
            this.contentData.details[2].text = this.CMSData.string_DoctorsDetailsQuoteWording3;
            //console.log('changed value = ', this.contentData);
    
          }
          if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.contentData.header = this.CMSData.string_DoctorsDetailsQuoteTitleDependant;
          this.contentData.introduction =
          this.CMSData.html_DoctorsDetailsQuoteSubtitleDependant.replace(/<p/gm,'<p class="dependent-subTitle"');
          }
        });
      }
      /** End of code block for CMS */

}
